import * as PropTypes from "prop-types";
import styled from "styled-components";
import History from "utils/history";
import Header from "basicComponents/Header/Header";
import {Close as CloseIcon} from "@material-ui/icons";
import {IconButton} from "@material-ui/core";

function handlePatientOverviewPageClose() {
  History.goBack();
}

export default function ForegroundBlobFakeModalHeader({
  children,
  onClose,
  enableLargePadding,
  noUnderline,
  noPadding,
  contentClassName,
  enableIconPadding = false,
  disableMargin = false,
}) {
  return (
    <HeaderWrapper noPadding={noPadding} data-cy="modalHeader">
      <Header
        center
        enableLargePadding={enableLargePadding}
        disableMargin={disableMargin}
      >
        <Content
          className={contentClassName}
          enableIconPadding={enableIconPadding}
        >
          <div id="spacer" />
          {children}
          <IconButton
            onClick={onClose || handlePatientOverviewPageClose}
            data-cy="headerCloseButton"
          >
            <CloseIcon />
          </IconButton>
        </Content>
        {!noUnderline && <Divider />}
      </Header>
    </HeaderWrapper>
  );
}

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  ${({ theme, enableIconPadding }) =>
    enableIconPadding && `padding-right: ${theme.padding}rem`};
`;

const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;

  ${({ theme, noPadding }) =>
    !noPadding && `padding-bottom: ${theme.padding}rem`};
`;

const Divider = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.margin * 2}rem;

  border-bottom: solid ${({ theme }) => theme.dividerColor} 2px;
`;

ForegroundBlobFakeModalHeader.propTypes = {
  children: PropTypes.any,
  onClose: PropTypes.func,
  enableLargePadding: PropTypes.bool,
  noUnderline: PropTypes.bool,
  noPadding: PropTypes.bool,
  disableMargin: PropTypes.bool,
  enableIconPadding: PropTypes.bool,
};
